import React from "react";

import FilterButtons from './FilterButtons';
import CategoryBlocks from './CategoryBlocks';
import SkillsBlocks from './SkillsBlocks';
import InterestBlocks from './InterestBlocks';
import EducationBlocks from './EducationBlocks';
import FilterSummaryBar from './FilterSummaryBar';
import { Loader2, MoveRight } from "lucide-react";

const FilterBar = ({ filters, activeFilter, setActiveFilter, selectedFilters, onToggleItem, onToggleDisplayView, onClearFilter, onClearAll, jobCount }) => {
  return (
    <div className="flex flex-1 flex-col h-full items-center overflow-y-auto w-full overflow-x-hidden gap-2 md:px-10">

      <FilterButtons activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
      {!filters && <Loader2 className="animate-spin mt-10 text-white" size={40}/>}
      {filters && (<FilterSummaryBar onClearAll={onClearAll} filters={filters} activeFilter={activeFilter} selectedFilters={selectedFilters} onClearFilter={onClearFilter}/>)}
      {filters && (
        <div className="overflow-y-auto w-full mb-2 no-scrollbar">
            {activeFilter === 'categories' && (<CategoryBlocks data={filters.categories} selected={selectedFilters.categories} onToggle={onToggleItem} />)}
            {activeFilter === 'qualities' && (<SkillsBlocks data={filters.qualities} selected={selectedFilters.qualities} onToggle={onToggleItem} />)}
            {activeFilter === 'interests' && (<InterestBlocks data={filters.interests} selected={selectedFilters.interests} onToggle={onToggleItem} />)}
            {activeFilter === 'study_levels' && (<EducationBlocks data={filters.study_levels} selected={selectedFilters.study_levels} onToggle={onToggleItem} />)}
        </div>
      )}
      {filters && (
        <div className="w-full mb-4 flex mt-auto">
          <div className="w-full bottom">
            <button
              className="w-full px-4 py-1 rounded-xl bg-teal-500"
              onClick={() => onToggleDisplayView('jobs')}
            >
              <span className="text-2xl pr-2">🔥</span><span>Découvrir {jobCount} métiers <MoveRight className="pl-2 inline" size={35} /></span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterBar;
